module.exports = __webpack_public_path__ + "img/7a54f7a1b4881101713be8eeda60740a.742ad18c.jpg";